import * as requestFromServer from "./Curd";
import { NewAdscompanylistSlice, callTypes } from "./Slice";
import { NotificationManager } from "react-notifications";

const { actions } = NewAdscompanylistSlice;

export const fetchAdsLogListList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));

  return requestFromServer
    .getAdsLogListList(queryParams)
    .then((response) => {
      console.log("response::fetchAdsLogListList ", response);
      const totalCount = response.data[0]?.param?.totalRecords;
      const entities = response.data[0]?.param?.data;

      // If the entities array is not empty, map the data to the rows array
      const rows = entities.map((logEntry) => ({
        noIndex: logEntry._id, // Assuming '_id' is unique and can be used as a unique identifier for each row
        user_id: logEntry.user_id,
        company_id: logEntry.company_id,
        brand_name: logEntry.brand_name,
        country: logEntry.country,
        ads_id: logEntry.ads_id,
        date: logEntry.date,
        time: logEntry.date, // Assuming you want to display the same value for 'Date' and 'Time'
        log_type: logEntry.log_type,
      }));

      console.log("resoponceeeeeeeeeeee", totalCount, rows);

      dispatch(actions.contestListList({ totalCount, entities: rows }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      const totalCount = 0;
      const entities = [];
      dispatch(actions.contestListList({ totalCount, entities }));
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountriesList = (queryParams) => (dispatch) => {
  console.log("queryParams -> user -> com:", queryParams);
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryList = response;
      console.log("countryList", countryList);
      dispatch(actions.CountryList({ countryList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountriesDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryDropdownList = response;
      console.log("countryDropdownList", countryDropdownList);
      dispatch(actions.CountryDropdownList({ countryDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCompany(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.company({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchcurrencyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getcurrency(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.currency({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
